import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Book from "@/pages/Book";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/Calendar";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import PropertyDetail from "@/pages/PropertyDetail";
import Reminders from "@/pages/Reminders";
import EmailsSent from "@/pages/EmailsSent";
import Invoices from "@/pages/Invoices";
import PublicInvoice from "@/pages/PublicInvoice";
import Settings from "@/pages/Settings";
import Sales from "@/pages/Sales";
import Expenses from "@/pages/Expenses";
import Field from "@/pages/Field";
import Import from "@/pages/Import";

const RequireAuth = ({ children }) => {
    const { isAuthed, ready } = useAuth();
    if (!ready) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="text-label">Loading…</p>
            </div>
        );
    }
    if (!isAuthed) return <Navigate to="/login" replace />;
    return children;
};

const AppRoutes = () => (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/book" element={<Book />} />
        <Route path="/i/:id" element={<PublicInvoice />} />
        <Route
            path="/"
            element={
                <RequireAuth>
                    <Layout />
                </RequireAuth>
            }
        >
            <Route index element={<Navigate to="/field" replace />} />
            <Route path="field" element={<Field />} />
            <Route path="due-soon" element={<Dashboard />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="properties/:id" element={<PropertyDetail />} />
            <Route path="reminders" element={<Reminders />} />
            <Route path="emails" element={<EmailsSent />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="sales" element={<Sales />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="settings" element={<Settings />} />
            <Route path="import" element={<Import />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);

function App() {
    const basename = process.env.REACT_APP_BASENAME || "/admin";
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter basename={basename}>
                    <AppRoutes />
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
